import "./contact.scss";
import { motion } from "framer-motion";
// import { useForm, ValidationError } from '@formspree/react';
import github from "../../images/github.svg";
import medium from "../../images/medium-blue.svg";
import hashnode from "../../images/hashnode-icon.png";

const Contact = () => {
  return (
    <section id="contact">
      <div className="container-homeCon relative overflow-hidden">
        <div className="cc">
          <div className="informationC">
            <motion.div
              className="font-face-nh sticky"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.0 }}
              transition={{ delay: 0.5, duration: 3.0 }}
              variants={{
                hidden: { opacity: 0, y: 50 },
                visible: { opacity: 1, y: 0 },
              }}
            >
              <h1 className="first-nameCon">Contact</h1>
            </motion.div>
          </div>
        </div>

        <div className="containerC-right">
          <div className="font-face-n text-white text-sm cr1 lg:text-lg">
            <h3 className="mt-0 lg:w-2/3">
              Any questions? I am here to help. You can contact me through the
              contact form below or mail be directly at
              <br />
              shreyaschaliha27@protonmail.com.
            </h3>
            <h3 className="mt-5">* Required</h3>
            <div className="contact-form mt-1">
              <form action="https://formspree.io/f/xjvdyabv" method="POST">
                <div className="mt-5">
                  <label className="">
                    Name*
                    <input
                      required
                      type="text"
                      placeholder="First and Last name"
                      className="border-1 hover:underline flex mt-2 p-3 outline-none text-center"
                      name="name"
                    />
                  </label>
                </div>

                <div className="mt-5">
                  <label className="">
                    Email*
                    <input
                      required
                      type="text"
                      placeholder="Email address"
                      className="border-1 hover:underline flex mt-2 p-3 outline-none text-center"
                      name="email"
                    />
                  </label>
                </div>

                <div className="mt-5">
                  <label className="">
                    Subject*
                    <input
                      required
                      type="text"
                      placeholder="Subject"
                      className="border-1 hover:underline flex mt-2 p-3 outline-none text-center"
                      name="subject"
                    />
                  </label>
                </div>
                <div className="mt-5">
                  <label className="overflow-hidden">
                    Message*
                    <input
                      required
                      type="text"
                      placeholder="Message"
                      className="border-1 hover:underline flex mt-2 p-3 outline-none text-center"
                      name="message"
                    />
                  </label>
                </div>

                <div className="button__log mt-[5vh]">
                  <button
                    type="submit"
                    className="bg-black text-white p-2 w-3/5"
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
            <div className="social media mt-[4vh] w-3/5 flex gap-7">
              <a
                className="hover:opacity-50 transition duration-500"
                href="https://github.com/trace2798"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="twitter-link" src={github} className="w-8 h-8" />
              </a>
              <a
                className="hover:opacity-50 transition duration-500"
                href="https://shreyas-chaliha.hashnode.dev/"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="hashnode-link" src={hashnode} className="w-8 h-8" />
              </a>
              <a
                className="hover:opacity-50 transition duration-500"
                href="https://medium.com/@shreyaschaliha27"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="linkedin-link" src={medium} className="w-8 h-8" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
